import Operations from "./opentrip.storage";

const OperationsController = {
    async openTrip(data){
      const response = await Operations.openTrip('/', data)
      return response;
    },
    async updateOpenTrip(data){
      const response = await Operations.updateOpenTrip('/', data)
      return response;
    },
    async listTripsOpenTrips(data){
      const response = await Operations.listTripsOpenTrips('/trip-opentrips', data)
      return response;
    },
    async getPassengers(data){
      const response = await Operations.getPassengers('/all-by-open-trip-for-admin', data)
      return response;
    },

}

export default OperationsController;